import { getAppConfig } from '../../config/appConfig.js'
import { runExitHooks } from '../../services/exitHooks.js'

interface ExitAudit {
  impersonatorId: string
  impersonatedId: string
}

/**
 * Ends impersonation by handing back to the platform's "leave impersonation"
 * flow, which re-mints the admin's normal session and lands them in the platform
 * admin area — the admin has no native identity in this app (spec FR-007). Falls
 * back to the platform logout URL, then a local `/login`, so the admin is never
 * trapped (spec Edge Cases). Registered exit hooks run first — a held section lock
 * must be released while the impersonated session's cookie is still valid — bounded
 * so a slow API cannot strand the admin here.
 *
 * Records `impersonation.exit_clicked` (FR-011) — the one impersonation event the
 * web can witness. The structured console line is the hook point for real
 * telemetry; the impersonation START is audited platform-side.
 */
export async function leaveImpersonation(audit?: ExitAudit): Promise<void> {
  const config = getAppConfig()
  const target = config.platformImpersonationLeaveUrl || config.platformLogoutUrl || '/'

  console.info({
    event: 'impersonation.exit_clicked',
    impersonatorId: audit?.impersonatorId,
    impersonatedId: audit?.impersonatedId,
  })

  await runExitHooks()
  window.location.assign(target)
}
